module.exports = __webpack_public_path__ + "img/domestic.560353ea.jpg";